import { Component, Inject } from '@angular/core';
import { CrewPermissionsService } from '../../core/crew-permissions.service';

@Component({
    selector: 'crew-requirementsections',
    template: require('./requirement-sections.component.html')
})
export class RequirementSections {

    isPermissionWriteOrAdmin: boolean;

    constructor(
        @Inject("requirementSections") public requirementSections: Nema.Crew.Model.CompetenceRequirementCollection[],
        @Inject("authorities") public authorities: Nema.Crew.Model.Authority[],
        crewPermissionsService: CrewPermissionsService) {

        crewPermissionsService.isPermissionWriteOrAdmin().subscribe(value => this.isPermissionWriteOrAdmin = value);
    }

    public newEntityState = "app.settings.requirementsections.new";

    public editEntityState = "app.settings.requirementsections.detail";

    public entityName = RequirementSections.entityName;

    public static entityName = "Requirement Section";

    public entityNames = "Requirement Sections";
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/settings/requirementsections/requirement-sections.component.ts